import { render } from "./github-commands.vue?vue&type=template&id=61ed4ee2"
import script from "./github-commands.vue?vue&type=script&lang=js"
export * from "./github-commands.vue?vue&type=script&lang=js"

import "./github-commands.vue?vue&type=style&index=0&id=61ed4ee2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__